import {
  ReferrerCodeLookupResponse,
  ReferrerCodeRepository
} from '@/repositories/members/ReferrerCodeRepository';

import { ONBOARDING_QUERY_KEY_PREFIX } from '../pages/Onboarding/components/Stepper';

import useAPI from './useAPI';

export const useReferrerCodeLookup = ({
  code,
  enabled = true
}: {
  code?: string;
  enabled?: boolean;
} = {}) => {
  const referrerCodeRepository = ReferrerCodeRepository();

  return useAPI<ReferrerCodeLookupResponse[]>({
    queryKey: [ONBOARDING_QUERY_KEY_PREFIX, 'referrer-code', code],
    queryFn: async () => {
      if (!code) {
        return [];
      }
      return await referrerCodeRepository.lookup(code);
    },
    refetchOnWindowFocus: false,
    enabled: !!code && enabled
  });
};
